
export default defineNuxtPlugin((nuxt) => {

  nuxt.provide('stringifySafe', (obj: any) => safeStringify(obj));
})



const safeStringify = (obj: any) => {
  const cache = new Set();
  return JSON.stringify(obj, (key, value) => {
    if (typeof value === 'object' && value !== null) {
      if (cache.has(value)) {
        return; // Remove circular references
      }
      cache.add(value);
    }
    return value;
  });
};